import type { SubscriptionPlan, SubscriptionStatus } from "@/types/organization";

export interface BillingProfile {
  organizationId: string;
  plan: SubscriptionPlan;
  status: SubscriptionStatus;
  seatsUsed: number;
  seatsLimit: number;
  storageUsedBytes: number;
  storageLimitBytes: number;
  currentPeriodEnd?: string;
}

export interface BillingInvoice {
  id: string;
  organizationId: string;
  invoiceNumber: string;
  amount: number;
  currency: string;
  status: "draft" | "open" | "paid" | "void" | "uncollectible";
  issuedAt: string;
  paidAt?: string;
  hostedUrl?: string;
}

export const PLAN_CATALOG = {
  starter: { name: "Individual", monthlyPrice: 399, seats: 1, storageGb: 10, activeEvents: 10 },
  studio: { name: "Studio", monthlyPrice: 899, seats: 5, storageGb: 50, activeEvents: 40 },
  agency: { name: "Agency", monthlyPrice: 1899, seats: 15, storageGb: 200, activeEvents: 150 },
  enterprise: { name: "Enterprise", monthlyPrice: null, seats: 999, storageGb: 1000, activeEvents: 999 },
} satisfies Record<SubscriptionPlan, { name: string; monthlyPrice: number | null; seats: number; storageGb: number; activeEvents: number }>;
